import stateManager from './stateManager';
import { WtaEndpointResponse } from './throttler';
import event from './event';

export interface Specs {
    pageType: string;
    force?: boolean;
};
export type SendPageview = (specs: Specs) => Promise<WtaEndpointResponse>;
export const sendPageview: SendPageview = ({ pageType, force = false }) => {
    stateManager.update({ pageType });
    return event(
        {
            type: 'pageview',
            meta:
            { eventTime: new Date },
        },
        { force }
    );
};
